var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "delete-btn",
    width: 30,
    height: 30,
    viewBox: "0 0 150 150",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 130,
    x2: 120,
    y2: 130,
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 40,
    x2: 132,
    y2: 40,
    strokeWidth: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 45,
    x2: 33,
    y2: 134,
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 48,
    x2: 51,
    y2: 123,
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 48,
    x2: 75,
    y2: 123,
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 48,
    x2: 98,
    y2: 123,
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 15,
    x2: 113,
    y2: 15,
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 45,
    x2: 116,
    y2: 134,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9935 14.0378L28 38",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.926 14L122 38",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.cd74625ef206bf8f299abed8648e45b3.svg";
export { ForwardRef as ReactComponent };